export default __webpack_public_path__ + "static/media/1742.13952914.png";